import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const zebraPrintLocaleModule: LocaleModule = {
  name: "zebraPrint",
  messages: { en: en, it: it },
};
